import { useThemeStore } from "../store/theme";
import type { ThemePreference } from "../hooks/useTheme";

const options: {
  value: ThemePreference;
  icon: string;
  label: string;
}[] = [
  { value: "light", icon: "bi-sun", label: "Light theme" },
  { value: "system", icon: "bi-display", label: "Match system theme" },
  { value: "dark", icon: "bi-moon-stars", label: "Dark theme" },
];

const ThemeToggle: React.FC = () => {
  const themePreference = useThemeStore((s) => s.themePreference);
  const setThemePreference = useThemeStore((s) => s.setThemePreference);

  return (
    <div className="themeToggle" role="group" aria-label="Theme">
      {options.map((opt) => {
        const active = themePreference === opt.value;
        return (
          <button
            key={opt.value}
            type="button"
            className={`themeToggle__btn${
              active ? " themeToggle__btn--active" : ""
            }`}
            onClick={() => setThemePreference(opt.value)}
            aria-pressed={active}
            aria-label={opt.label}
            title={opt.label}
          >
            <i className={`bi ${opt.icon}`} aria-hidden="true" />
          </button>
        );
      })}
    </div>
  );
};

export default ThemeToggle;
